import React, { Component } from 'react'
import { Button } from 'react-bootstrap'

class ServiceBenefitsTab extends Component {
    
    onCardClick = (event)=> {
        event.stopPropagation()
        if (this.props.onBenefitSelect) this.props.onBenefitSelect(event.target.value.trim())
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    renderBenefits() {
        //console.log(this.props);
        let { benefits = [] } = this.props.services
        let { filter = {} } = this.props.services
        let rows = (
            <fieldset>
                <legend className="visuallyhidden">Select a Benefit</legend>
                <ul className="services-row list-style">
                    {benefits.map((benefit, i) => (
                        <li className="col benefit-item button-checkbox col-md-4 col-xs-4 col-sm-1">
                            <span tabindex="0" class="user-list-item">
                                <input
                                    id={'benefit-' + i}
                                    onClick={this.onCardClick}
                                    checked={filter.selectedBenefit === benefit}
                                    value={benefit}
                                    tabindex="-1"
                                    type="radio"
                                />
                                <label htmlFor={'benefit-' + i} class="img-responsive-wrapper font-size-p2 gotham-xn-medium">
                                    <div
                                        data-test-id="benefits-names"
                                        className={`filter-benefits-button text-center title-hover datecard-hover font-size-p2 gotham-xn-medium ${
                                            filter.selectedBenefit === benefit ? 'selected-day-card' : ''
                                            }`}>
                                        {' '}
                                        {benefit}
                                    </div>
                                </label>
                            </span>
                        </li>
                    ))}
                </ul>
            </fieldset>
        )
        if (this.props.isMobileView)
            rows = benefits.map((benefit) => (
                <Button
                    onClick={this.onCardClick}
                    className={`filter-benefits-button mobile-filter-button font-size-p2 gotham-xn-medium ${
                        filter.selectedBenefit === benefit ? 'selected-day-card' : ''
                        } `}>
                    {' '}
                    {benefit}
                </Button>
            ))

        return rows
    }

    render() {
        return <section className="service-benefits-container">
            <h2 className='visuallyhidden'>Select a Benefit</h2>
            {this.renderBenefits()}
        </section>
    }
}

export default ServiceBenefitsTab
